interface IconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

export function CloseIcon({ size = 24, color, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="currentColor"
      style={color ? { color } : undefined}
      className={className}
      aria-hidden="true"
    >
      <path d="M2.23438 3.28125C1.94063 2.9875 1.94063 2.5125 2.23438 2.22187C2.52813 1.93125 3.00313 1.92812 3.29376 2.22187L8.01251 6.94062L12.7313 2.22187C13.025 1.92812 13.5 1.92812 13.7906 2.22187C14.0813 2.51562 14.0844 2.99062 13.7906 3.28125L9.07188 8L13.7906 12.7188C14.0844 13.0125 14.0844 13.4875 13.7906 13.7781C13.4969 14.0687 13.0219 14.0719 12.7313 13.7781L8.01251 9.05937L3.29376 13.7781C3.00001 14.0719 2.52501 14.0719 2.23438 13.7781C1.94376 13.4844 1.94063 13.0094 2.23438 12.7188L6.95313 8L2.23438 3.28125Z" />
    </svg>
  );
}
